import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  .desktop {
    display: flex;
    height: 100%;
    width: 100%;
    @media (${theme.devices.tablet}) {
      display: none;
    }
  }
  .mobile {
    display: none;
    @media (${theme.devices.tablet}) {
      height: 100%;
      width: 100%;
      display: flex;
    }
  }
`;
export const Lbl = styled.span``;
export const DgTilte = styled.span`
  margin-right: 2vw;
  font-size: 12px;
  font-weight: 800;
`;
export const RulesText = styled.p`
  color: black;
  font-size: ${theme.fontSize.base};
`;
export const RulesContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;
